import { ProfileInfoResponse } from 'all-in-one-shared-api';
import { ProfileProps } from '../ProfilePage';
import ProfileRowInfo from './ProfileRowInfo';
import { useTranslation } from 'react-i18next';
import { StyledTitle } from 'components/StyledTitle';
import React from 'react';

const ProfilePolicyInfo = ({ data }: ProfileProps): JSX.Element => {
  const { t } = useTranslation();
  const toLabel = t('common.to');
  const policyDetails = getPolicyDetails(toLabel, data);
  const membershipDetails = getMembershipDetailsProps(toLabel, data);

  return (
    <>
      <StyledTitle level={4} margin="32px 0 10px 0">
        {t('profile.policyDetails')}
      </StyledTitle>
      <ProfileRowInfo label={t('profile.policyNumber')} value={data?.policyNumber ?? ''} />
      {Boolean(policyDetails?.previousEffectivePeriod) && (
        <ProfileRowInfo
          label={t('profile.previousEffectivePeriod')}
          value={policyDetails?.previousEffectivePeriod ?? ''}
        />
      )}

      <ProfileRowInfo label={t('profile.currentEffectivePeriod')} value={policyDetails?.currentEffectivePeriod} />

      <StyledTitle level={4} margin="32px 0 10px 0">
        {t('profile.memberDetails')}
      </StyledTitle>
      <ProfileRowInfo label={t('profile.memberId')} value={data?.memberId ?? ''} />
      {Boolean(membershipDetails?.previousEffectivePeriod) && (
        <ProfileRowInfo
          label={t('profile.previousEffectivePeriod')}
          value={membershipDetails?.previousEffectivePeriod}
        />
      )}
      <ProfileRowInfo label={t('profile.currentEffectivePeriod')} value={membershipDetails?.currentEffectivePeriod} />
    </>
  );
};

function getPolicyDetails(toLabel: string, data?: ProfileInfoResponse) {
  let previousEffectivePeriod = '';
  let currentEffectivePeriod = '';
  if (data?.previousPolicyStartDate && data.previousPolicyEndDate) {
    previousEffectivePeriod = `${data.previousPolicyStartDate} ${toLabel} ${data.previousPolicyEndDate}`;
  }
  if (data?.currentPolicyStartDate && data.currentPolicyEndDate) {
    currentEffectivePeriod = `${data.currentPolicyStartDate} ${toLabel} ${data.currentPolicyEndDate}`;
  }

  return {
    previousEffectivePeriod: previousEffectivePeriod,
    currentEffectivePeriod: currentEffectivePeriod,
  };
}

function getMembershipDetailsProps(toLabel: string, data?: ProfileInfoResponse) {
  let previousEffectivePeriod = '';
  let currentEffectivePeriod = '';

  if (data?.previousMemberStartDate && data.previousMemberEndDate) {
    previousEffectivePeriod = `${data.previousMemberStartDate} ${toLabel} ${data.previousMemberEndDate}`;
  }

  if (data?.currentMemberStartDate && data.currentMemberEndDate) {
    currentEffectivePeriod = `${data.currentMemberStartDate} ${toLabel} ${data.currentMemberEndDate}`;
  }

  return {
    previousEffectivePeriod,
    currentEffectivePeriod,
  };
}

export default ProfilePolicyInfo;
